import { Reveal } from "@/components/common/Reveal";

const cards = [
    {
        title: "Haras & bâtiments équestres",
        text: "Boxes, écuries et installations pensées pour le bien-être du cheval.",
        img: "/images/equestrian1.jpg",
        span: "lg:col-span-7 lg:row-span-2",
        h: "min-h-[280px] lg:min-h-[560px]",
    },
    {
        title: "Stabulations bovines",
        text: "Vaches laitières, bovins à viande et nurseries pour veaux.",
        img: "/images/cattle.jpg",
        span: "lg:col-span-5",
        h: "min-h-[280px] lg:min-h-[270px]",
    },
    {
        title: "Chèvreries, bergeries & porcheries",
        text: "Des bâtiments d'élevage sur mesure, adaptés à chaque activité.",
        img: "/images/livestock.jpg",
        span: "lg:col-span-5",
        h: "min-h-[280px] lg:min-h-[270px]",
    },
    {
        title: "Hangars agricoles & solaires",
        text: "Stockage de matériel et toitures conçues pour le photovoltaïque.",
        img: "/images/solar2.jpg",
        span: "lg:col-span-6",
        h: "min-h-[280px]",
    },
    {
        title: "Écuries & manèges couverts",
        text: "Des espaces lumineux et sains, conçus autour du vivant.",
        img: "/images/barn-exterior.jpg",
        span: "lg:col-span-6",
        h: "min-h-[280px]",
    },
];

const Card = ({ c, i }) => (
    <Reveal delay={(i % 3) * 0.08} className={c.span}>
        <article
            data-testid={`realisation-card-${i}`}
            className={`group relative h-full ${c.h} overflow-hidden rounded-2xl`}
        >
            <img
                src={c.img}
                alt={c.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform [transition-duration:1200ms] ease-out group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-rz-deep/90 via-rz-deep/20 to-transparent" />
            <div className="relative z-10 flex h-full flex-col justify-end p-7">
                <h3 className="font-display text-xl md:text-2xl font-bold text-white">
                    {c.title}
                </h3>
                <p className="mt-2 text-sm text-white/75 max-w-md opacity-0 translate-y-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                    {c.text}
                </p>
            </div>
        </article>
    </Reveal>
);

export const Realisations = () => (
    <section
        data-testid="realisations-section"
        className="relative bg-rz-bg py-24 lg:py-32 px-6 md:px-12"
    >
        <div className="mx-auto max-w-[1400px]">
            <div className="max-w-2xl mb-14">
                <Reveal>
                    <span className="text-xs tracking-[0.22em] uppercase text-rz-sage font-semibold">
                        Nos réalisations
                    </span>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="font-display mt-5 text-[clamp(2rem,4.5vw,3.4rem)] font-bold tracking-tight leading-[1.05] text-rz-ink">
                        Des bâtiments conçus sur mesure, pour chaque activité.
                    </h2>
                </Reveal>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 auto-rows-auto">
                {cards.map((c, i) => (
                    <Card key={c.title} c={c} i={i} />
                ))}
            </div>
        </div>
    </section>
);
